<div class="w-[96px]">
  <div
    class="relative w-[96px] h-[96px] p-1 mb-2 rounded-lg"
    [ngClass]="
      userHasAccess
        ? 'bg-borders-dark ring-[5px] ring-completed'
        : 'bg-borders-dark'
    "
  >
    <img
      class="absolute inset-y-2/4 -translate-y-2/4 left-1/2 -translate-x-2/4 w-[80px] block"
      [src]="getServiceLogoPath(streamingService.service.id)"
      alt="{{ streamingService.service.name }}"
    />
    @if (streamingService.link) {
    <div class="absolute top-0 right-0 w-[26px] p-[4px] bg-black rounded-bl-lg">
      <span
        class="block w-[18px] h-[18px] bg-white"
        style="
          -webkit-mask: url(&quot;/assets/images/icons/link.svg&quot;);
          mask: url(&quot;/assets/images/icons/link.svg&quot;);
          -webkit-mask-size: 18px 18px;
          mask-size: 18px 18px;
        "
      ></span>
    </div>
    } @if (streamingService.expiresSoon) {
    <div
      class="absolute w-full bottom-0 left-0 py-[2px] bg-primary text-xs text-black font-bold rounded-b-lg"
    >
      {{ "EXPIRES_SOON" | translate }}
    </div>
    }
  </div>
  <span
    class="font-bold inline-block overflow-hidden whitespace-nowrap text-ellipsis max-w-full"
    >{{ streamingService.service.name }}</span
  >
  <div class="text-sm text-grey dark:text-borders-dark">
    {{ getStreamingTypeLabel$(streamingService.type) | async }}
  </div>
  @if ( streamingService.type !== streamingTypes.Subscription &&
  streamingService.type !== streamingTypes.Free &&
  streamingService.price?.amount ) {
  <div>
    <span class="text-sm font-bold text-grey dark:text-borders-dark"
      >{{ streamingService.price?.amount }}
      {{ streamingService.price?.currency }}</span
    >
  </div>
  }
</div>
